import { debounce } from 'lodash';

export default {
    data() {
        return {
            showErrorPopup: false,
            // Hide error message must be in data to be unique to each instance of the mixin, otherwise only
            // the latest component's error message will be hidden
            hideErrorMessagePopup: debounce(function () {
                this.showErrorPopup = false;
            }, 2500),
        };
    },
    watch: {
        error: {
            handler: function (newError) {
                if (!newError) {
                    // Don't show an error message if there's no error
                    return;
                }
                this.showErrorPopup = true;
                // Schedule the hide error message popup after a delay
                this.hideErrorMessagePopup();
            },
            deep: true, // Re-show error message even if true is assigned multiple times in a row
        },
    },
}
